import * as React from "react"
import {Box} from "@mui/material";
import {formatNumber} from "@ui-seeker/utils";

import {ArrowBackground} from "@components";
import {formatMinAge} from "@utils";


export default function numberColumn(name, label, decimals=0) {
	return [{
		name, label,
		options: {
			filter: false,
			setCellHeaderProps: () => ({ sx: {
					whiteSpace: 'pre-wrap',
					minWidth: 160
				}}),
			customBodyRowRender: (value, dataRow) => {
				const check = dataRow[`${name}_kpi`]

				let backgroundColor = 'divider'
				if (check !== null)
					backgroundColor = check ? 'success.lighter'  : 'error.lighter'

				return <Box sx={{ textAlign: 'center', fontSize: 14 }}>
					<ArrowBackground value={value} backgroundColor={backgroundColor}>
						{name === 'min_age' ? formatMinAge(value) : formatNumber(value, {decimals: decimals})}
					</ArrowBackground>
				</Box>
			}
		}
	},
	{
		name, label,
		options: {
			display: 'excluded',
			customBodyRowRender: (_, dataRow) => {
				const check = dataRow[`${name}_kpi`]
				if (check === null)
					return 'N/A'
				return check ? 'Yes' : 'No'
			}
		}
	}]
}